<template>
  <div id="shopNoticeContent"></div>
</template>

<script>
import E from "wangeditor";

let editor = null;
export default {
  name: "noticeDialog",
  props: ["value"],
  data() {
    return {};
  },
  mounted() {
    // 注：class写法需要在componentDidMount 创建编辑器
    editor = new E("#shopNoticeContent");

    editor.config.onchange = newHtml => {
      // this.onChange(newHtml);
      this.$emit("onChange", newHtml);
    };

    // 需要展示的菜单
    editor.config.menus = [];

    /**一定要创建 */
    editor.create();
    editor.disable();
    editor.txt.html(this.value);
  },
  destroyed() {
    // 组件销毁时销毁编辑器 注：class写法需要在componentWillUnmount中调用
    editor.destroy();
  },
  watch: {
    value(val, old) {
      if (editor) {
        editor.txt.html(val);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/notice/editor.vue